
/* eslint-disable */
import {
   defineComponent,
   PropType,
   onMounted,
   reactive,
   toRef,
   toRefs,
   ref,
   computed,
   watch
} from "vue";
import $api from "@/api/main";
export default defineComponent({
   props: {
      /**
       *  传入的当前流程信息
       */
      modelValue: {
         type: Object as PropType<any>,
         default: (): any => {
            return [];
         },
      },
      /**
       *  当前流程的信息
       */
      workflowType: {
         type: String,
         default: '',
      },
   },
   setup(props, ctx) {
      const selectAuditUser = ref();
      let selectNode:any = ref({});
      const visible = ref(false);
      const departmentDir:any = {
         '项目经理':'engineering',
         '材料员':'material',
         '预算员':'business',
         '预算部经理':'business',
         '财务员':'finance',
         '行政员':'comprehensive',
         '副总经理':'manager',
         '总经理':'comprehensive',
         '分管领导':'manager',
         '质安员':'quality',
         '质安负责人':'quality',
      };

      const data: any = reactive({
         tree: [],
         flowList: props.modelValue,
         expand: [],
         pathTable: {},
      });

      /**
       * 获取员工树
       */
      const createPathTable = (
         tree: any[],
         pathArray: any[],
         indexs: any[]
      ) => {
         for (let index = 0; index < tree.length; index++) {
            pathArray.push(tree[index].code);
            indexs.push(index);
            data.pathTable[tree[index].code] = {
               path: [...pathArray],
               name: tree[index].name,
               indexs: [...indexs],
               selectable: tree[index].selectable,
            };
            if (tree[index].children) {
               createPathTable(tree[index].children, pathArray, indexs);
            }
            pathArray.pop();
            indexs.pop();
         }
      };

      /**
       * 获取员工树
       */
      const getStaffTree = async () => {
         data.tree = await $api.getStaffTree({
            deptCode: departmentDir[selectNode.taskName]?departmentDir[selectNode.taskName]:''
         });
         createPathTable(data.tree, [], []);
      };

      /**
       * 获取流程节点信息并回显审核人
       */
      const getProcessNodeInfoFn = async () => {
         let result = await $api.getProcessNodeInfo(props.workflowType);
         result.forEach((item:any)=>{
            data.flowList.push({
               assignee:'',
               assigneeName:'',
               taskDefinitionKey: item.id,
               taskName: item.name
            });
         });
      };

      /**
       * 新增审核人
       */
      const appendFn = (node:any)=>{
         selectAuditUser.value = '';
         visible.value = !visible.value;
         selectNode = node;
         getStaffTree();
      }

      /**
       * 移除审核人
       */
      const deleFn = (node:any)=>{
         node.assignee = '';
         node.assigneeName = '';
      }
      /**
       * 修改审核人
       */
      const clickAavatarFn = (node:any)=>{
         selectNode = node;
         visible.value = !visible.value;
         selectAuditUser.value = node.assignee;
         getStaffTree();
      }

      /**
       * 监听审核人的code变化
       */
      watch(()=>selectAuditUser.value,()=>{
         if(selectAuditUser.value){
            selectNode.assignee = selectAuditUser.value;
            selectNode.assigneeName = data.pathTable[selectAuditUser.value].name;
         }
      })

      onMounted(() => {
         if(data.flowList.length === 0) getProcessNodeInfoFn();
      });

      return {
         data,
         createPathTable,
         selectAuditUser,
         visible,
         appendFn,
         deleFn,
         clickAavatarFn,
      };
   },
});
